import { css } from 'styled-components';
import token from 'styled-token';
import { StyledIcon } from '../../components/Icon/Icon.styles';
var todayCSS = function todayCSS(props) {
  if (!props.today) {
    return '';
  }
  return token('Button.tertiary.borderColor', function (borderColor) {
    return borderColor && "\n                &:not([aria-pressed=\"true\"]),\n                &:not([aria-pressed=\"true\"]):focus {\n                    border-color: " + borderColor + ";\n                }\n            ";
  })(props);
};

/** @class DatePickerButtonMixin */
/** @method */
/** CDS-2187: Extra specificity for SSR */
export var DatePickerButtonMixin = function DatePickerButtonMixin(props) {
  return token({
    borderRadius: 'DatePickerButton.borderRadius',
    size: 'DatePickerButton.size',
    padding: 'DatePickerButton.padding',
    iconMargin: 'DatePickerButton.Icon.margin'
  }, function (_ref) {
    var borderRadius = _ref.borderRadius,
      size = _ref.size,
      iconMargin = _ref.iconMargin,
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? 0 : _ref$padding;
    return css(["&&&{border-radius:", ";height:", "px;width:", "px;display:flex;align-items:center;justify-content:center;padding:", "px;", " &:disabled{text-decoration:line-through;}", "{margin:", ";}}"], borderRadius, size, size, padding, todayCSS(props), StyledIcon, iconMargin);
  })(props);
};